import loginDonor from "@/components/pages/loginDonor/loginDonor";
import ldForgotPassword from "@/components/pages/loginDonor/ldForgotPassword";
import createNewAccount from "../../components/pages/loginDonor/createNewAcount/createNewAccount";
import cnaRequestActivationCode from "@/components/pages/loginDonor/createNewAcount/cnaRequestActivationCode";
import cnaEnterActivationCode from "@/components/pages/loginDonor/createNewAcount/cnaEnterActivationCode";
import donorProfile from "@/components/pages/donorProfile";
import resetPassword from "../../components/pages/resetPassword";
import confirmationPage from "../../components/pages/confirmPage";
import ldForgotDonorId from "@/components/pages/loginDonor/ldForgotDonorId";
import appointmentConformationPage from "@/components/pages/appointmentConformationPage";

export default [
    {
        path        : '/login-donor/',
        name        : 'loginDonor',
        component   : loginDonor,
        meta: {
            afterLoginDonor: true,
            redirectName: 'myDonations',
        }
    },
    {
        path        : '/login-donor/forgot-password/',
        name        : 'ldForgotPassword',
        component   : ldForgotPassword,
    },
    {
        path        : '/login-donor/forgot-donor-id/',
        name        : 'ldForgotDonorId',
        component   : ldForgotDonorId,
    },
    {
        path        : '/login-donor/create-new-account',
        name        : 'ldCreateNewAccount',
        component   : createNewAccount,
    },
    {
        path        : '/login-donor/create-new_account/request-activate-code/',
        name        : 'cnaRequestActivationCode',
        component   : cnaRequestActivationCode,
        meta : {
            triggerRequestActivationCode: true,
            redirectName: 'ldCreateNewAccount'
        }
    },
    {
        path        : '/login-donor/create-new_account/enter-activate-code/',
        name        : 'cnaEnterActivationCode',
        component   : cnaEnterActivationCode,
        meta : {
            triggerEnterActivationCode: true,
            redirectName: 'ldCreateNewAccount'
        }
    },
    {
        path        : '/donor-profile/',
        name        : 'donorProfile',
        component   : donorProfile,
    },
    {
        path        : '/reset-password/',
        name        : 'resetPassword',
        component   : resetPassword,
    },
    {
        path        : '/confirmation-page/',
        name        : 'confirmationPage',
        component   : confirmationPage,
    },
    {
        path        : '/appointment-confirmation-success/',
        name        : 'appointmentConformationPage',
        component   : appointmentConformationPage,
    },
]
